import { render, staticRenderFns } from "./CreateMixCampaign.vue?vue&type=template&id=2027e3e2&scoped=true&"
import script from "./CreateMixCampaign.vue?vue&type=script&lang=ts&"
export * from "./CreateMixCampaign.vue?vue&type=script&lang=ts&"
import style0 from "./CreateMixCampaign.vue?vue&type=style&index=0&id=2027e3e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2027e3e2",
  null
  
)

export default component.exports